import { Link } from "react-router-dom";
import { categories, topics } from "@/mocks/topics";

export default function CategorySection() {
  return (
    <section id="categories" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
              按类型找线索
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热点分类
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              同类事件的处理逻辑往往相似。先按分类进入，你可以更快找到关心的那条脉络。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            浏览全部事件
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const count = topics.filter((t) => t.categoryId === cat.id).length;
            return (
              <Link
                key={cat.id}
                to={`/topics?cat=${cat.id}`}
                className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${cat.icon} text-2xl`}></i>
                  </span>
                  <span className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-500">
                    {count} 起复盘
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-600">{cat.desc}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}